const ptTranslations = {
  // Hero
  'hero.title': 'Lavanderia Self-Service em BH - Aberta 6h às 23h',
  'hero.title.meta': 'Lavanderia Self-Service BH | Eco Lavanderia Express',
  'hero.subtitle': 'Lavanderia moderna com autoatendimento 24h. Produtos premium Omo e Comfort inclusos. Secagem rápida em apenas 45 minutos!',
  'hero.whatsapp': 'Fale no WhatsApp',
  'hero.location': 'Ver Localização',
  'hero.feature.drying': 'Secagem 45min',
  'hero.feature.premium': 'Produtos Premium',
  'hero.feature.humanized': 'Atendimento Humanizado',
  
  // Services
  'services.title': 'Nossos Serviços',
  'services.subtitle': 'Soluções completas para cuidar das suas roupas',
  'services.selfService.title': 'Autoatendimento',
  'services.selfService.description': 'Máquinas modernas de 10kg. Você mesmo lava e seca suas roupas.',
  'services.selfService.price': 'A partir de R$ 16,99',
  'services.fullService.title': 'Serviço Completo',
  'services.fullService.description': 'Deixe com a gente! Lavamos, secamos e dobramos suas roupas.',
  'services.fullService.price': 'A partir de R$ 25,00',
  'services.everyday.title': 'Roupas Dia a Dia',
  'services.everyday.description': 'Camisetas, calças, roupas íntimas e toalhas.',
  'services.everyday.price': 'A partir de R$ 12,00',
  'services.bedding.title': 'Edredons e Cobertores',
  'services.bedding.description': 'Peças grandes com tratamento especial.',
  'services.bedding.price': 'A partir de R$ 30,00',
  'services.humanized.title': 'Atendimento Humanizado',
  'services.humanized.description': 'Nossa equipe está sempre pronta para ajudar você com atenção e carinho. Sabemos que cada peça tem seu valor e cuidamos de tudo com dedicação.',
  'services.humanized.cta': 'Fale Conosco',
  'services.differentials.title': 'Nossos Diferenciais',
  'services.differentials.care': 'Cuidado Especial',
  'services.differentials.care.desc': 'Tratamento personalizado para cada tipo de roupa',
  'services.differentials.fast': 'Rapidez',
  'services.differentials.fast.desc': 'Secagem em 45 minutos',
  'services.differentials.quality': 'Qualidade',
  'services.differentials.quality.desc': 'Produtos premium Omo e Comfort',
  'services.differentials.care2': 'Cuidado com Roupas Delicadas',
  'services.differentials.care2.desc': 'Programas especiais para peças sensíveis',
  'services.differentials.support': 'Suporte Sempre Disponível',
  'services.differentials.support.desc': 'Equipe pronta para ajudar',
  
  // Pricing
  'pricing.title': 'Preços e Horários',
  'pricing.subtitle': 'Transparência e facilidade para você',
  'pricing.selfService.title': 'Autoatendimento',
  'pricing.selfService.price': 'R$ 16,99',
  'pricing.selfService.period': 'por lavagem',
  'pricing.selfService.features.washing': 'Lavagem completa',
  'pricing.selfService.features.products': 'Produtos inclusos (Omo e Comfort)',
  'pricing.selfService.features.drying': 'Secagem 45 minutos',
  'pricing.selfService.features.wifi': 'Wi-Fi grátis enquanto espera',
  'pricing.selfService.cta': 'Começar Agora',
  'pricing.fullService.title': 'Serviço Completo',
  'pricing.fullService.price': 'R$ 29,99',
  'pricing.fullService.period': 'por lavagem',
  'pricing.fullService.popular': 'Mais Popular',
  'pricing.fullService.features.full': 'Lavagem + Secagem completas',
  'pricing.fullService.features.fold': 'Dobramos suas roupas',
  'pricing.fullService.features.products': 'Produtos premium inclusos',
  'pricing.fullService.features.delivery': 'Entrega em 24h',
  'pricing.fullService.features.support': 'Atendimento personalizado',
  'pricing.fullService.cta': 'Solicitar Serviço',
  'pricing.schedule.title': 'Horários',
  'pricing.schedule.days': 'Segunda a Domingo',
  'pricing.schedule.hours': '6h às 23h',
  'pricing.schedule.last': 'Último atendimento: 22:30',
  'pricing.schedule.info': 'Autoatendimento disponível 24h com acesso por aplicativo',
  'pricing.schedule.cta': 'Ver no Mapa',
  
  // Space
  'space.title': 'Nosso Espaço',
  'space.subtitle': 'Ambiente moderno e confortável',
  'space.amenities.title': 'Comodidades',
  'space.amenities.wifi': 'Wi-Fi Grátis',
  'space.amenities.ac': 'Ar-Condicionado',
  'space.amenities.parking': 'Delivery na Região',
  'space.amenities.cameras': 'Câmeras de Segurança',
  'space.amenities.eco': 'Produtos Ecológicos',
  'space.amenities.accessibility': 'Acessibilidade',
  'space.amenities.led': 'Iluminação LED',
  'space.amenities.safe': 'Ambiente Seguro',
  'space.cta': 'Conheça Pessoalmente',
  
  // Location
  'location.title': 'Nossa Localização',
  'location.subtitle': 'Fácil acesso e delivery na região',
  'location.address': 'Endereço',
  'location.address.street': 'Av. Álvares Cabral, 894',
  'location.address.neighborhood': 'Lourdes, Belo Horizonte - MG',
  'location.phone': 'Telefone / WhatsApp',
  'location.phone.number': '(31) 99990-1010',
  'location.hours': 'Horário de Funcionamento',
  'location.hours.days': 'Segunda a Domingo',
  'location.hours.time': '6h às 23h',
  'location.highlights': 'Pontos de Referência',
  'location.highlights.shopping': 'Próximo ao Minas Shopping',
  'location.highlights.parking': 'Delivery na região',
  'location.highlights.access': 'Fácil acesso pela Av. Álvares Cabral',
  'location.cta': 'Como chegar',
  
  // Reviews
  'reviews.title': 'O Que Nossos Clientes Dizem',
  'reviews.subtitle': 'Avaliações reais de quem já usou nossos serviços',
  'reviews.cta': 'Deixe Sua Avaliação',
  
  // FAQ
  'faq.title': 'Perguntas Frequentes',
  'faq.subtitle': 'Tire suas dúvidas sobre nossos serviços',
  
  // Footer
  'footer.about': 'Sobre',
  'footer.about.description': 'Lavanderia moderna com autoatendimento 24h e serviço completo. Cuidamos das suas roupas com carinho e dedicação.',
  'footer.quickLinks': 'Links Rápidos',
  'footer.contact': 'Contato',
  'footer.contact.address': 'Av. Álvares Cabral, 894 - Lourdes, BH',
  'footer.contact.phone': '(31) 99990-1010',
  'footer.contact.email': 'contato@ecolavanderia.com.br',
  'footer.social': 'Redes Sociais',
  'footer.rights': 'Todos os direitos reservados.',
  
  // NotFound
  'notfound.title': 'Página Não Encontrada',
  'notfound.description': 'Ops! A página que você está procurando não existe ou foi movida.',
  'notfound.home': 'Voltar ao Início',
  'notfound.contact': 'Falar Conosco',
  'notfound.links': 'Links úteis:',
  'notfound.services': 'Serviços',
  'notfound.location': 'Localização',
  'notfound.reviews': 'Avaliações',
};

export default ptTranslations;
